// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"profileEdit__gradient-bg5__SoyMf","section":"profileEdit__section__u0Dq8"};